export default __webpack_public_path__ + "static/media/DL_printing_rules_mm.4768056f.pdf";